<template>
  <div>
    <template v-if="isCompose">
      <!-- radio v-modal:current shape: pc / mobile / all  -->
      <div>
        shape:

        <label>
          <input v-model="currentShape" type="radio" value="pc" />
          pc
        </label>
        <label>
          <input v-model="currentShape" type="radio" value="mobile" />
          mobile
        </label>
        <label>
          <input v-model="currentShape" type="radio" value="all" />
          all
        </label>
      </div>
      <template v-if="currentShape === 'all'">
        pc width <input v-model="composePcWidth" type="number" value="0" />
        <div
          :style="{
            width: composePcWidth ? composePcWidth + 'px' : '100%',
            boxShadow: '0 0 0 1px #ff777777 '
          }"
        >
          <adsmart-ui-switch
            :ads-board-identify="boardInfo.identify"
            :ads-keyword-input="adsKeywordInput"
            :ads-custno="adsCustno"
            ads-shape="pc"
          />
        </div>
        <hr />
        mobile width
        <input v-model="composeMobileWidth" type="number" value="390" />
        <div
          :style="{
            width: composeMobileWidth ? composeMobileWidth + 'px' : '100%',
            boxShadow: '0 0 0 1px #ff777777'
          }"
        >
          <adsmart-ui-switch
            :ads-board-identify="boardInfo.identify"
            :ads-keyword-input="adsKeywordInput"
            :ads-custno="adsCustno"
            ads-shape="mobile"
          />
        </div>
      </template>
      <template v-else>
        width
        <input v-model="composePcWidth" type="number" value="390" />
        <div
          :style="{
            width: composePcWidth ? composePcWidth + 'px' : '100%',
            boxShadow: '0 0 0 1px #ff777777'
          }"
        >
          <adsmart-ui-switch
            :ads-board-identify="boardInfo.identify"
            :ads-keyword-input="adsKeywordInput"
            :ads-custno="adsCustno"
            :ads-shape="currentShape"
          />
        </div>
      </template>
    </template>

    <adsmart-ui
      v-else
      :ads-board-identify="boardInfo.identify"
      :ads-keyword-input="adsKeywordInput"
      :ads-custno="adsCustno"
    />
  </div>
</template>

<script>
import { COMPOSE_TYPE } from "@/adsmart-ui/settings/enum/type.js";

export default {
  props: {
    boardInfo: {},
    adsKeywordInput: {},
    adsCustno: {}
  },
  data() {
    return {
      currentShape: "all",
      composePcWidth: 0,
      composeMobileWidth: 390
    };
  },
  computed: {
    isCompose() {
      return Object.values(COMPOSE_TYPE).some(
        type => type === this.boardInfo.typeId
      );
    }
  },
  methods: {}
};
</script>
